// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-offline{display:flex;justify-content:center;align-items:center}.app-offline__content{flex:1 1 auto;margin-top:50px;padding:20px}.app-offline__logo{display:block;margin:0 auto 20px}.app-offline__title{margin-bottom:30px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
